import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router';
import Scroller from 'ui-component/Scroller';
import { setLoading } from 'store/reducers/mainSlice';
import { FaPlus, FaSave, FaSpinner } from 'react-icons/fa';
import Select from 'react-select';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import toast from 'react-hot-toast';
import Switch from '@mui/material/Switch';
import { FormControl } from '@mui/material'
import useIsMobile from 'utils/isMobileUtils';
import ReactSelectCreatable from 'react-select/creatable';
import { Skeleton } from '@mui/material';

const ProductForm = ({ edit }) => {
	const { id } = useParams();
	const history = useNavigate();
	const nameRef = useRef();
	const skuRef = useRef();
	const modelRef = useRef();
	const warehouseRef = useRef();
	const [status, setStatus] = useState(false)
	const [publishInClientPortal, setPublishInClientPortal] = useState(false)
	const [productTypelist, setProductTypeList] = useState([]);
	const [alertMessage, setAlertMessage] = useState();
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
	const [warehouseList, setWarehouseList] = useState([]);
	const [modelList, setModelList] = useState([]);
	const [selectedWarehouses, setSelectedWarehouses] = useState([]);
	const [priceMargin, setPriceMargin] = useState(0);
	const [isLoading, setIsLoading] = useState(true);

	const [productDetail, setProductDetail] = useState({
		name: '',
		sku: '',
		modelCategory: '',
		warehouses: [],
		status: 1,
		price: '',
		purchasePrice: '',
		productCodeSupplier: '',
		deliveryTime: '',
		minimumOrder: '',
		orderQuantity: '',
		productType: '',
		modelId: '',
		customModelName: '',
		inPortal: 1
	});


	const categoryWithourVariant = [
		'Accessories', 'Parts', 'Cables'
	];

	const loadProductCategories = () => {
		api.getAllProductCategoriesLite().then((res) => {
			if (res.status) {
				let typeTemp = res.data.map((item) => ({ ...item }));
				setProductTypeList(typeTemp);
			} else {
			}
		});
	};

	const loadModels = () => {
		api.getSelectOptionsList('model').then((res) => {
			const tempSelect = res.data.map((item) => ({ id: item.id, name: item.name }));
			setModelList(tempSelect);
		});
	};
	const loadWarehouses = () => {
		api.getSelectOptionsList('warehouse').then((res) => {
			const tempSelect = res.data.map((item) => ({ id: item.id, name: item.name }));
			const mergedSelect = [...tempSelect];
			setWarehouseList(mergedSelect);
	if (productDetail?.warehouses.length < 1 && mergedSelect.length > 0) {
            const firstWarehouse = mergedSelect[0];
            const defaultWarehouse = [{
                id: firstWarehouse.id,
                value: firstWarehouse.id,
                label: firstWarehouse.name,
            }];
            setProductDetail({ ...productDetail, warehouses: defaultWarehouse });
            setSelectedWarehouses(defaultWarehouse);
        }
		});
	};

	const handleChange = (val) => {
		setProductDetail(val);
	};


	const handleWarehouseChange = (val) => {
		const newSelectedWarehouse = val.map(item => ({
			id: item.value,
			value: item.value,
			label: item.label,
		}));
		setProductDetail({ ...productDetail, warehouses: newSelectedWarehouse });
		setSelectedWarehouses(newSelectedWarehouse);
	};

	const handleStatus = (val) => {
		setProductDetail({ ...productDetail, status: (val === true) ? 1 : 0 });
		setStatus(val)
	}

	const handlePublishInClientPortal = (val) => {
		setProductDetail({ ...productDetail, inPortal: (val === true) ? 1 : 0 });
		setPublishInClientPortal(val)
	}

	const handleComputePriceMargin = (purchasePrice, sellingPrice) => {
		let marginPercentage = 0;
		if (parseInt(sellingPrice) < parseInt(purchasePrice)) {
			marginPercentage = ((parseFloat(sellingPrice) - parseFloat(purchasePrice)) / parseFloat(purchasePrice)) * 100;
		} else {
			marginPercentage = ((parseFloat(sellingPrice) - parseFloat(purchasePrice)) / parseFloat(sellingPrice)) * 100;
		}

		if (isNaN(marginPercentage)) {
			setPriceMargin(0);
		} else {

			if (sellingPrice != '0.00' || purchasePrice != '0.00') {
				setPriceMargin(Math.round(marginPercentage));
			} else {
				setPriceMargin(0);
			}
		}
	}
	useEffect(() => {

	}, [productDetail])

	const handleSubmit = (e) => {
		
		if (edit && id) {
			e.preventDefault();

			if (productDetail.modelId === '' && productDetail.customModelName === '') {
				toast.error('Model is Required.');
				modelRef.current.focus();
				return false;
			} else if (productDetail.customModelName !== '' && (productDetail.modelCategory === null || productDetail.modelCategory === '') ) {
				toast.error('Please Select Category.');
				return false;
			} else if (productDetail.name == '') {
				toast.error('Product Name is Required.');
				nameRef.current.focus();
				return false;
			} else if (productDetail.sku.trim() === '') {
				toast.error('SKU is Required.');
				skuRef.current.focus();
				return false;
			} else if (productDetail.warehouses.length < 1) {
				toast.error('Warehouse is Required.');
				return false;
			}
			
			setIsSubmitDisabled(true);
			api
			.updateProduct(id, {
				sku: productDetail?.sku,
				name: productDetail?.name,
				product_category_id: productDetail?.modelCategory,
				warehouses: productDetail?.warehouses,
				status: productDetail?.status,
				price: productDetail?.price,
				purchase_price: productDetail?.purchasePrice,
				in_portal: publishInClientPortal,
				model_id: productDetail?.modelId,
				custom_model_name: productDetail?.customModelName,
			})
			.then(
				(res) => {
					if (res.status) {
						toast.success(res.message);
						history(`/products/${res.data.id}`);
					} else {
						if (res.errors?.name) {
							setAlertmessage({
								name: res.errors.name
							});
							nameRef.current.focus();
						} else {
							toast.error(res.message);
						}
					}

					setIsSubmitDisabled(false);
					return res?.status ? res : null;
				},
				() => {
					setIsSubmitDisabled(false);
				}
			);
		} else {
			e.preventDefault();

			if (productDetail.modelId === '' && productDetail.customModelName === '') {
				toast.error('Model is Required.');
				modelRef.current.focus();
				return false;
			} else if (productDetail.customModelName !== '' && (productDetail.modelCategory === null || productDetail.modelCategory === '') ) {
				toast.error('Please Select Category.');
				return false;
			} else if (productDetail.name == '') {
				toast.error('Product Name is Required.');
				nameRef.current.focus();
				return false;
			} else if (productDetail.sku.trim() === '') {
				toast.error('SKU is Required.');
				skuRef.current.focus();
				return false;
			} else if (productDetail.warehouses.length < 1) {
				toast.error('Warehouse is Required.');
				return false;
			}

			setIsSubmitDisabled(true);
			api.createProduct({
				sku: productDetail?.sku,
				name: productDetail?.name,
				product_category_id: productDetail?.modelCategory,
				warehouses: productDetail?.warehouses,
				status: productDetail?.status,
				price: productDetail?.price,
				purchase_price: productDetail?.purchasePrice,
				in_portal: productDetail?.inPortal,
				model_id: productDetail?.modelId,
				custom_model_name: productDetail?.customModelName,
			}).then((res) => {
				setIsSubmitDisabled(false);
				if (res.status) {
					toast.success(res.message);
					history(`/products/${res?.data?.id}`);
				} else {
					if (res.errors?.name) {
						setAlertmessage({
							name: res.errors.name
						});
						nameRef.current.focus();
					} else {
						toast.error(res.message);
					}
				}

				setIsSubmitDisabled(false);

			});;
		}
	};
	useEffect(() => {

		loadProductCategories();
		loadWarehouses();
		loadModels();
		if (edit) {
			getProductDetails();
		} else {
			setIsLoading(false);
		}
	}, []);

	const getProductDetails = () => {
		setIsLoading(true);
		api.getProductDetails(id).then((res) => {
			setIsLoading(false);
			if (!res.data) {
				setLoading(true);
				history('/products');
			} else {
				const loadData = res?.data;
				let tempdata = {
					sku: loadData?.sku || '',
					name: loadData?.product_name || '',
					modelCategory: loadData?.category || '',
					warehouses: loadData?.warehouses || [],
					status: loadData?.status || 0,
					price: loadData?.price || '',
					purchasePrice: loadData?.purchase_price || '',
					productCodeSupplier: loadData?.product_code_supplier || '',
					deliveryTime: loadData?.delivery_time || '',
					minimumOrder: loadData?.minimum_order || '',
					orderQuantity: loadData?.order_quantity || '',
					productType: loadData?.product_type || '',
					inPortal: loadData?.in_portal || 0,
					modelId: loadData?.model?.id || '',
				};
				setProductDetail(tempdata);
				if (loadData?.status === 1) {
					setStatus(true);
				} else {
					setStatus(false);
				}
				if (loadData?.in_portal === 1) {
					setPublishInClientPortal(true)
				} else {
					setPublishInClientPortal(false);
				}

				const sellingPrice = loadData?.price;
				const purchasePrice = loadData?.purchase_price;
				const marginPercentage = ((sellingPrice - purchasePrice) / sellingPrice) * 100;

				if (sellingPrice != '0.00' || purchasePrice != '0.00') {
					setPriceMargin(100 - Math.round(marginPercentage));
				} else {
					setPriceMargin(0);
				}
				setSelectedWarehouses(loadData?.warehouses || []);
				setLoading(true);
			}
		});
	};
	const goback = () => {
		history('/products');
	};

	const isMobile = useIsMobile();
	return (
		<div className="row m-0 create-contact-container">
			<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
				<div className="header-bubble" />
				<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
					<div
						style={{
							position: 'relative',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							marginBottom: 8,
							minHeight: 38 // ensures enough height for the button
						}}
					>
						{' '}
						<button
							type="button"
							aria-label="Back"
							onClick={() => history(-1)}
							className="circle-back-btn"
							style={{
								position: 'absolute',
								left: 20,
								top: '50%',
								transform: 'translateY(-50%)'
							}}
						>
							{/* Replace with your fi arrow icon, example below */}
							<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
								<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</button>
						<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>{edit ? 'Edit Product' : 'Create Product'}</h5>
					</div>
					<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
						{edit ? (
							<PermissionAllowed permissions={['Save Contact Details (Action)']}>
								<button type="button" className={isSubmitDisabled ? `btn btn-main disabled` : `btn btn-main`} disabled={isSubmitDisabled} onClick={handleSubmit}>
									{isSubmitDisabled ? (
										<>
											<FaSpinner className="fa-spin" /> Saving Changes...
										</>
									) : (
										<>
											<FaSave /> Save Changes
										</>
									)}
								</button>
							</PermissionAllowed>
						) : (
							<PermissionAllowed permissions={['Create New Contact (Action)']}>
								<button
									type="button"
									className={isSubmitDisabled ? `btn btn-main disabled` : `btn btn-main`}
									disabled={isSubmitDisabled}
									onClick={handleSubmit}
								>
									{isSubmitDisabled ? (
										<>
											<FaSpinner className="fa-spin" /> Creating Product...
										</>
									) : (
										<>
											<FaPlus /> Create Product
										</>
									)}
								</button>
							</PermissionAllowed>
						)}
					</div>
				</div>
			</div>
			<div
				className={`${isMobile ? 'mobile-scroll-container w-100 mobile-scroll-container-xsmaller' : 'card w-100 h-100 '}`}
				style={{ marginTop: isMobile ? '0px' : '20px', paddingBottom: isMobile ? '90px' : '' }}
			>
				<form action="" className="h-100" onSubmit={handleSubmit}>
					<div className="section-head m-0 p-0 hide-on-mobile">
						<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
							{edit ? 'Edit Product' : 'Create Product'}
						</h5>
					</div>
					<Scroller>
						<div className="form-section">
							<div className="form-section-head">
								<h4>General Information</h4>
							</div>
						</div>

						<div className="form-section">
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">Model</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div>
												<ReactSelectCreatable
													ref={modelRef}
													className="rs-container"
													classNamePrefix="rs"
													options={modelList?.map((item) => ({ label: item.name, value: item.id }))}
													onChange={(e) => {
														// handleChange({ ...productDetail, modelId: e?.__isNew__ ? '' : e.value || '', customModelName: e?.__isNew__ ? e.value : '' });
														handleChange({ 
															...productDetail, 
															modelId: e?.__isNew__ ? '' : e.value || '', 
															customModelName: e?.__isNew__ ? e.value : '', 
															modelCategory: e?.__isNew__ ? null : productDetail.modelCategory 
														});
													}}
													isMulti={false}
													value={productDetail.modelId
														? modelList
															.map((item) => ({ label: item.name, value: item.id }))
															?.find((c) => c?.value == productDetail?.modelId)
														: productDetail.customModelName
															? { label: productDetail.customModelName, value: productDetail.customModelName }
															: null}
													menuPlacement="auto"
													menuPosition="fixed"
													placeholder="Select or type..."
												/>
											</div>
										)
									}
								</div>
								<div className="form-group-error">
									{alertMessage?.modelId && (
										<span className="error-message text-danger">{alertMessage.modelId}</span>
									)}
								</div>
							</div>
							{
								productDetail?.customModelName && (
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">Category</label>
											{
												isLoading ? (
													<div style={{ width: '240px' }}>
														<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
													</div>
												) : (

													<Select
														options={productTypelist.map((e) => ({
															value: e.id,
															label: e.name,
															hasGrade: e.has_grade_variations,
															hasColor: e.has_color_variations,
															hasStorage: e.has_storage_variations
														}))}
														className="rs-container"
														classNamePrefix="rs"
														onChange={(e) => {
															handleChange({ ...productDetail, modelCategory: e.value });
														}}
														placeholder="Select or type..."
													/>
												)
											}
										</div>
										<div className="form-group-error">
											{alertMessage?.modelType && (
												<span className="error-message text-danger">{alertMessage.modelType}</span>
											)}
										</div>
									</div>
								)
							}
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">Product Name</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div>
												{edit ? (
													<input
														ref={nameRef}
														type="text"
														className="form-control"
														placeholder="Enter Product Name"
														value={productDetail?.name}
														onChange={(e) => {
															handleChange({ ...productDetail, name: e.target.value });
														}}
													/>
												) : (
													<input
														ref={nameRef}
														type="text"
														className="form-control"
														placeholder="Enter Product Name"
														onChange={(e) => {
															handleChange({ ...productDetail, name: e.target.value });
														}}
													/>
												)}
											</div>
										)
									}
								</div>
								<div className="form-group-error">
									{alertMessage?.name && (
										<span className="error-message text-danger">{alertMessage.name}</span>
									)}
								</div>
							</div>
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">SKU</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div>
												<input
													ref={skuRef}
													type="text"
													className="form-control"
													placeholder="Enter SKU"
													maxLength={50}
													value={productDetail?.sku}
													onChange={(e) => {
														handleChange({ ...productDetail, sku: e.target.value });
													}}
												/>
											</div>
										)
									}
								</div>
								<div className="form-group-error">
									{alertMessage?.sku && (
										<span className="error-message text-danger">{alertMessage.sku}</span>
									)}
								</div>
							</div>
						</div>
						{edit && (
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">Status</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div>
												<FormControl sx={{ width: '100% ' }}>
													<Switch color="primary" checked={status} onChange={(event) => handleStatus(event.target.checked)} />
												</FormControl>
											</div>
										)
									}
								</div>
							</div>
						)}
						<div className="form-group">
							<div className="form-group-body">
								<label htmlFor="">Publish in Client Portal</label>
								{
									isLoading ? (
										<div style={{ width: '240px' }}>
											<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
										</div>
									) : (
										<div>
											<FormControl sx={{ width: '100% ' }}>
												<Switch
													color="primary"
													checked={publishInClientPortal}
													onChange={(event) => handlePublishInClientPortal(event.target.checked)}
												/>
											</FormControl>
										</div>
									)
								}
							</div>
						</div>

						<div className="form-section" style={{ marginTop: '20px' }}>
							<div className="form-section-head">
								<h4>Pricing</h4>
							</div>
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">Sales Price ($)</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div>
												<input
													value={productDetail?.price}
													type="number"
													className="form-control"
													id="inputName"
													placeholder="0"
													onChange={(e) => {
														const val = e.target.value;
														if (/^\d*\.?\d*$/.test(val)) {
															// regex to allow numbers and a single dot
															handleChange({ ...productDetail, price: val });
															handleComputePriceMargin(productDetail?.purchasePrice, val);
														}
													}}
												/>
											</div>
										)
									}
								</div>
							</div>
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">Purchase Price ($)</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
												<input
													value={productDetail?.purchasePrice}
													type="text"
													placeholder="0"
													className="form-control"
													id="inputName"
													onChange={(e) => {
														// handleChange({ ...productDetail, purchasePrice: e.target.value });
														// handleComputePriceMargin()
														const val = e.target.value;
														if (/^\d*\.?\d*$/.test(val)) {
															// regex to allow numbers and a single dot
															handleChange({ ...productDetail, purchasePrice: val });
															handleComputePriceMargin(val, productDetail?.price);
														}
													}}
												/>
												<div className="textGray product-price-margin-label">Margin: {priceMargin}%</div>
											</div>
										)
									}
								</div>
							</div>
						</div>

						<div className="form-section" style={{ marginTop: '20px' }}>
							<div className="form-section-head">
								<h4>Location</h4>
							</div>
							<div className="form-group">
								<div className="form-group-body">
									<label htmlFor="">Warehouse</label>
									{
										isLoading ? (
											<div style={{ width: '240px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35}></Skeleton>
											</div>
										) : (
											<div className="">
												<Select
													ref={warehouseRef}
													isMulti={true}
													options={warehouseList.map((e) => ({
														value: e.id,
														label: e.name
													}))}
													value={selectedWarehouses?.map((warehouse) => ({
														value: warehouse.id,
														label: warehouseList.find((w) => w.id === warehouse?.id)?.name || 'empty'
													}))}
													className="rs-container"
													classNamePrefix="rs"
													onChange={(e) => {
														handleWarehouseChange(e);
													}}
													placeholder="Select or type..."
												/>
											</div>
										)
									}
								</div>
								<div className="form-group-error">
									{alertMessage?.warehouse && (
										<span className="error-message text-danger">{alertMessage.warehouse}</span>
									)}
								</div>
							</div>
						</div>

					</Scroller>

					<div className="non-scroll-btn-section hide-on-mobile ">
						<div className="btnarea">
							{edit ? (
								<PermissionAllowed permissions={['Save Contact Details (Action)']}>
									<button
										type="button"
										className={isSubmitDisabled ? `btn btn-main disabled` : `btn btn-main`}
										disabled={isSubmitDisabled}
										onClick={handleSubmit}
									>
										{isSubmitDisabled ? (
											<>
												<FaSpinner className="fa-spin" /> Saving Changes...
											</>
										) : (
											<>
												<FaSave /> Save Changes
											</>
										)}
									</button>
								</PermissionAllowed>
							) : (
								<PermissionAllowed permissions={['Create New Contact (Action)']}>
									<button
										type="button"
										className={isSubmitDisabled ? `btn btn-main disabled` : `btn btn-main`}
										disabled={isSubmitDisabled}
										onClick={handleSubmit}
									>
										{isSubmitDisabled ? (
											<>
												<FaSpinner className="fa-spin" /> Creating Product...
											</>
										) : (
											<>
												<FaPlus /> Create Product
											</>
										)}
									</button>
								</PermissionAllowed>
							)}
						</div>
						{alertMessage?.success && <span className="px-3 down-error text-success">{alertMessage?.success}</span>}
						{alertMessage?.failed && <span className="px-3 down-error text-danger">{alertMessage?.failed}</span>}
					</div>
				</form>
			</div>
		</div>
	);
};

export default ProductForm;
